import AccessTimeIcon from "@mui/icons-material/AccessTime"
import React, { useMemo } from "react"
import Colors from "../../../utils/Colors"
import { PROCESS_STATUS } from "../../../utils/constants/kypStatuses"
import { buildRiskColor, buildRiskMessage } from "../../../utils/functions"
import styles from "./styles"

const WaitingIcon = ({ style = {}, fontSize = 'medium' } = {}) => (
  <AccessTimeIcon fontSize={fontSize} style={{ color: Colors.waitingGray, ...style }} />
)

const BackgroundCheckScoreSummary = ({ scoreBoardData, status }) => {
  const classes = styles()
  const finalScore = useMemo(() => scoreBoardData?.final_score, [scoreBoardData])
  const riskColor = useMemo(() => buildRiskColor(scoreBoardData.risk), [scoreBoardData])
  const riskMessage = useMemo(() => buildRiskMessage(scoreBoardData.risk), [scoreBoardData])

  return (
    <div className={classes.scoreResume}>
      <div className={classes.info}>
        <span>Score Final: </span>
        {status === PROCESS_STATUS.PROCESSED ? (
          <span style={{ fontWeight: 600 }}>
            {`${finalScore} ${finalScore === 1 ? ' ponto' : ' pontos'}`}
          </span>
        ) : <WaitingIcon fontSize='small' />
        }
      </div>
      {status === PROCESS_STATUS.PROCESSED && (
        <div className={classes.info}>
          <span>Risco: </span>
          <span style={{ color: riskColor }}>
            {riskMessage}
          </span>
        </div>
      )}
    </div>
  )
}

export default BackgroundCheckScoreSummary
